// KWANKGM11020_事前審査結果入力（承認・不承認）（職員）
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axios from '../../axios';
import FooterPreExaminationResultInputStaff from '../../organisms/FooterPreExaminationResultInputStaff';
import StaffNavbar from '../../molecules/StaffNavbar';
import Messages from '../../molecules/Messages';
import LoadingModal from '../../molecules/LoadingModal';
import {
  approval_value,
  default_notice,
  detail_id,
} from '../../const/PreliminaryExaminationResultInput';
import { KWANKGM11020A01 } from '../../const/api_modules';

interface Props {
  reception_id: number;
  reception_cd: string;
  is_loading: boolean;
  setIsLoading: (flag: boolean) => void;
  status_code: number;
}

const PreliminaryExaminationResultInput: React.FC<Props> = ({
  reception_id,
  reception_cd,
  is_loading,
  setIsLoading,
  status_code,
}) => {
  const [result, setResult] = useState('');
  const [notice, setNotice] = useState('');
  const [error_message, setErrorMessage] = useState({
    result: '',
    notice: '',
    message: '',
    url: '',
  });

  /**
   * ラジオボタンの変更イベント
   * @param event チェンジイベント
   * @returns void
   */
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setResult(event.target.value);
  };

  /**
   * テキストエリアの変更イベント
   * @param event チェンジイベント
   * @returns void
   */
  const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNotice(event.target.value);
  };

  /**
   * デフォルトのお知らせを入力するを押下
   * @returns void
   */
  const handleClickDefault = () => {
    // 承認の場合
    if (result === approval_value.agree) {
      setNotice(default_notice.agree);
      return;
    }

    // 不承認の場合
    setNotice(default_notice.disagree);
  };

  /**
   * APIモジュールへリクエストをする
   * @returns AxiosResponse
   */
  const requestApi = async () => {
    try {
      setIsLoading(true);

      const payload = {
        module_name: KWANKGM11020A01,
        is_json: true,
        reception_cd: reception_cd,
        reception_id: reception_id,
        detail: [
          { id: detail_id, name: 'review_approval_status', value: result },
          { id: detail_id, name: 'review_message', value: notice },
        ],
      };
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/common`,
        payload
      );

      // APIからの結果がfalseの場合はスローする
      if (!response.data.result) {
        throw response;
      }

      // resolveする
      setIsLoading(false);
      return response;
    } catch (error) {
      // rejectする
      setIsLoading(false);
      throw error;
    }
  };

  /**
   * バリデーション処理へのリクエスト
   * @returns AxiosResponse
   */
  const validationRequest = async () => {
    try {
      setIsLoading(true);

      // エラーメッセージをリセットする
      setErrorMessage({ ...error_message, result: '', notice: '', message: '', url: '' });

      const payload = {
        result: result,
        notice: notice,
      };
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/reception/${reception_cd}/${reception_id}/result_input/validation`,
        payload
      );

      // レスポンスが正常であればresolveを返す
      // setIsLoading(false);
      return response;
    } catch (error) {
      // エラーメッセージを設定する
      if (typeof error.response.data.valid_message !== 'undefined') {
        setErrorMessage({
          ...error_message,
          result:
            'result' in error.response.data.valid_message
              ? error.response.data.valid_message.result[0]
              : '',
          notice:
            'notice' in error.response.data.valid_message
              ? error.response.data.valid_message.notice[0]
              : '',
        });
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <StaffNavbar user_role="staff" has_loan_aproval_system={false} />
      <div className="maintenance" id="preliminary_examination_result_input">
        <div className="title">事前審査結果入力(承認・不承認)</div>
        <div className="maintenance_container">
          <div className="contents">
            <Row>
              <Col md={3} sm={12}>
                事前審査結果
              </Col>
              <Col md={9} sm={12}>
                <div className="form-inline">
                  <div className="form-check mx-4">
                    <input
                      name="result"
                      type="radio"
                      id="agree"
                      className="form-check-input"
                      value={approval_value.agree}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" htmlFor="agree">
                      承認
                    </label>
                  </div>
                  <div className="form-check mx-4">
                    <input
                      name="result"
                      type="radio"
                      id="disagree"
                      className="form-check-input"
                      value={approval_value.disagree}
                      onChange={handleRadioChange}
                    />
                    <label className="form-check-label" htmlFor="disagree">
                      不承認
                    </label>
                  </div>
                  <div className="default_sentence_button">
                    <button
                      className="btn btn-bg-white btn-outline-success btn-text-color"
                      onClick={handleClickDefault}
                    >
                      デフォルトのお知らせを入力する
                    </button>
                  </div>
                </div>
                <Messages valid_msg={error_message.result} />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={3}>お客様へのお知らせ</Col>
              <Col>
                <div className="field-label-text annotation_text">
                  注意：減額承認などの保証条件等、特にお客様にご留意いただきたい内容がある場合、適宜テキストを変更して下さい
                </div>
                <textarea
                  rows={3}
                  className={`form-control ${error_message.notice && 'textarea_error'}`}
                  value={notice}
                  onChange={handleTextareaChange}
                ></textarea>
                <Messages valid_msg={error_message.notice} />
              </Col>
            </Row>
          </div>

          <FooterPreExaminationResultInputStaff
            requestModule={requestApi} // APIへのリクエスト
            validationRequest={validationRequest}
            reception_id={reception_id}
            reception_cd={reception_cd}
            status_code={status_code}
          />
        </div>
      </div>
      <LoadingModal show={is_loading} />
    </>
  );
};

export default PreliminaryExaminationResultInput;
